import { render, staticRenderFns } from "./top20List.vue?vue&type=template&id=73377242&scoped=true&"
import script from "./top20List.vue?vue&type=script&lang=js&"
export * from "./top20List.vue?vue&type=script&lang=js&"
import style0 from "./top20List.vue?vue&type=style&index=0&id=73377242&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73377242",
  null
  
)

export default component.exports